import { render, staticRenderFns } from "./Cookiebar.vue?vue&type=template&id=1f9140d1&scoped=true&"
import script from "./Cookiebar.vue?vue&type=script&lang=js&"
export * from "./Cookiebar.vue?vue&type=script&lang=js&"
import style0 from "./Cookiebar.vue?vue&type=style&index=0&id=1f9140d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9140d1",
  null
  
)

export default component.exports